/**
 * Created by emanuele on 04/02/2017.
 */
import React, {Component} from 'react'
import { Modal } from 'semantic-ui-react'
import PropTypes from 'prop-types';
import CommessaDocumentCreator from "./CommessaDocumentCreator";

class ModalCommesseDocumentCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {isOpen:false};
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    onClickOk(){
        this.setState({ isOpen: false })
        if (this.props.onClickOk !== undefined){
            this.props.onClickOk();
        }
    }
    onClickCancel(){
        this.setState({ isOpen: false })
    }

    handleOpen = () => {
        this.setState({ isOpen: true })
    }

    handleClose = () => {
        this.setState({ isOpen: false })
    }

    render(){
        return <Modal
            size={"mini"}
            trigger={this.props.children}
            open={this.state.isOpen}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            closeIcon
        >
            <Modal.Header>{this.props.title}</Modal.Header>
            <Modal.Content>
                <CommessaDocumentCreator commessa={this.props.commessa} onCloseClick={this.handleClose}/>
            </Modal.Content>
        </Modal>
    }

}
ModalCommesseDocumentCreator.PropTypes = {
    title: PropTypes.string,
    idDivisione: PropTypes.number.isRequired,
    commessa: PropTypes.object.isRequired,
    onClickOk: PropTypes.func
}

ModalCommesseDocumentCreator.defaultProps = {
    title: "Attenzione",
};

export default ModalCommesseDocumentCreator


/** WEBPACK FOOTER **
 ** ./src/components/commesse/ModalCommesseDocumentCreator.js
 **/